var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecurso7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576.31 401.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f35a3a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.18,343.42c-5.55-3.43-10.03-8.33-12.95-14.17l-6.19-12.38-1.02,2.05,22.92,45.84c5.49,10.97,4.91,23.75-1.54,34.18-.56.9-1.15,1.77-1.78,2.61h59.9c7.99,0,15.29-4.51,18.86-11.65l20.61-41.22h-80.33c-6.53,0-12.92-1.81-18.47-5.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M555.21,0h-86.71c-7.99,0-15.29,4.51-18.86,11.65l-69.97,139.95,66.92,133.85,127.47-254.94c7.01-14.02-3.19-30.51-18.86-30.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M442.16,310.01c-.34-1.98-.98-3.96-1.95-5.9l-1.48-2.95-66.92-133.85-3.93-7.85-3.93-7.85-36.51-73.03c-3.57-7.14-10.87-11.65-18.86-11.65h-86.71c-15.67,0-25.86,16.49-18.86,30.51l94.01,188.02,3.93,7.85,3.93,7.85,10.9,21.81c3.57,7.14,10.87,11.65,18.86,11.65h86.71c.22,0,.44,0,.65-.01,3.29-.09,6.33-.92,9-2.3h0c8-4.12,12.72-13.18,11.15-22.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.16,334.62l-3.93-7.85h0l-3.93-7.86L126.67,11.65C123.1,4.51,115.8,0,107.82,0H21.11C5.44,0-4.76,16.49,2.25,30.51l179.69,359.38c3.57,7.14,10.87,11.65,18.86,11.65h86.71c.22,0,.43,0,.65-.01,15.3-.45,25.12-16.68,18.21-30.5l-18.21-36.42h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurso7);
export default __webpack_public_path__ + "static/media/Recurso 7.0662bd089fd6a23eefb371ba7d2c115e.svg";
export { ForwardRef as ReactComponent };